<div class="permission-tags-details-view-container" *ngIf="permissionsTagObject" fxLayout="column" fxLayoutGap="15px" >


  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).asf_360.write" (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane </h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100 ">
                <app-detail header="Grupa uprawnień" [value]="permissionsTagObject.name"></app-detail>
              </div>

<!--              <div fxFlex="50 " fxLayoutAlign="start center">-->
<!--                <app-detail-bool header="Aktywny" [value]="permissionsTagObject.active"></app-detail-bool>-->
<!--              </div>-->

            </div>


          </mat-card>
        </div>
      </div>





  </div>
</div>
